import { FieldError } from "@/components/ui/field";

export default function ValidationErrors({
  errors,
}: {
  errors: string[] | undefined;
}) {
  if (!errors?.length) {
    return null;
  }

  return (
    <FieldError>
      <ul>
        {errors.map((error) => (
          <li key={error}>{error}</li>
        ))}
      </ul>
    </FieldError>
  );
}
